<div class="full-height flex-column flex-grow-1">
    <div class="flex-grow-1">
        <ng-content></ng-content>
        <div class="ion-margin-horizontal">
            <ion-toggle
                justify="space-between"
                (ionChange)="onScheduleToggle($event, 'all', 'all')"
                [(ngModel)]="toggleAllShifts">
                <p class="h4 font-weight-medium">Send me all available shifts</p>
            </ion-toggle>
        </div>

        <div class="border-top ion-margin-horizontal">
            <h2 class="h4 font-weight-medium">Weekdays</h2>
            <ion-toggle
                justify="space-between"
                class="ion-margin-bottom"
                [(ngModel)]="availability['weekday']['morning']"
                (ionChange)="onScheduleToggle($event, 'morning', 'weekday')">
                Morning
            </ion-toggle>

            <ion-toggle
                justify="space-between"
                class="ion-margin-bottom"
                [(ngModel)]="availability['weekday']['evening']"
                (ionChange)="onScheduleToggle($event, 'evening', 'weekday')">
                Evening
            </ion-toggle>

            <ion-toggle
                justify="space-between"
                class="ion-margin-bottom"
                [(ngModel)]="availability['weekday']['overnight']"
                (ionChange)="onScheduleToggle($event, 'overnight', 'weekday')">
                Overnight
            </ion-toggle>

            <h2 class="h4 font-weight-medium">Weekends</h2>

            <ion-toggle
                justify="space-between"
                class="ion-margin-bottom"
                [(ngModel)]="availability['weekend']['morning']"
                (ionChange)="onScheduleToggle($event, 'morning', 'weekend')">
                Morning
            </ion-toggle>

            <ion-toggle
                justify="space-between"
                class="ion-margin-bottom"
                [(ngModel)]="availability['weekend']['evening']"
                (ionChange)="onScheduleToggle($event, 'evening', 'weekend')">
                Evening
            </ion-toggle>

            <ion-toggle
                justify="space-between"
                class="ion-margin-bottom"
                [(ngModel)]="availability['weekend']['overnight']"
                (ionChange)="onScheduleToggle($event, 'overnight', 'weekend')">
                Overnight
            </ion-toggle>
        </div>

        <div class="ion-margin-horizontal border-top ion-padding-top">
            <lib-button
                [hidden]="toggleExclusion()"
                [displayAsInlineText]="true"
                (onClick)="toggleExclusion.set(!toggleExclusion())">
                <lib-svg-icon
                    iconName="plus-thin"
                    color="var(--ion-color-orange)"
                    [size]="14"
                    class="margin-right-small" />
                Add exclusion
            </lib-button>

            <div [hidden]="!toggleExclusion()">
                <div class="flex align-items-center justify-content-space-between">
                    <h2 class="h4">Exclusion</h2>
                    <lib-button
                        (onClick)="removeExclusions()"
                        [displayAsInlineText]="true"
                        color="var(--ion-color-danger)">
                        <lib-svg-icon iconName="trash-outline" color="var(--ion-color-danger)" />
                        <span class="text-danger">Delete</span>
                    </lib-button>
                </div>

                <lib-checkbox-group-chips [options]="exclusionOptions" (onChange)="onExclusionChange()" />
            </div>
        </div>
    </div>
    <div class="flex-grow-0 flex-shrink-0 ion-padding ion-margin-bottom">
        <lib-button (onClick)="saveChanges()">{{ buttonLabel }}</lib-button>
    </div>
</div>
